import React, { useMemo, useState } from 'react';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { toast } from 'react-toastify';
import { Card, Container } from '@mui/material';
import Loading from '../../../layouts/loading';
import BreadCrumb from '../../../components/breadcrumb/BreadCrumbNavigation';
import TableWrapper from '../../../common/TableWrapper';
import { DEFAULT_TABLE_PAGE_LIMIT } from '../../../Constants/table.constants';
import { EMPLOYEE_TIMELINE_TABLE_COLUMNS, EMPLOYEE_TIMELINE_TABLE_DEFAULT_PROPS } from './constants';
import { getusertimeline } from '../../../services/employeeService';

function EmployeesTimelineTable() {
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: DEFAULT_TABLE_PAGE_LIMIT,
  });

  const columns = useMemo(() => EMPLOYEE_TIMELINE_TABLE_COLUMNS, []);
  const {
    data: { totalCount = 0, data = [] } = {},
    isError,
    isRefetching,
    refetch,
    isLoading,
  } = useQuery({
    queryKey: [columnFilters, globalFilter, pagination.pageIndex, pagination.pageSize, sorting],
    queryFn: async () => {
      try {
        const response = await getusertimeline({
          start: pagination.pageIndex * pagination.pageSize,
          pageSize: pagination.pageSize,
          sorting: JSON.stringify(sorting ?? []),
          globalFilter,
        });
        return response?.data?.data;
      } catch (error) {
        toast.error('An error occurred while fetching the task list. Please try again later.');
        return { totalCount: 0, data: [] };
      }
    },
    placeholderData: keepPreviousData,
  });

  const table = useMaterialReactTable({
    columns,
    data,
    onColumnFiltersChange: setColumnFilters,
    onPaginationChange: setPagination,
    onGlobalFilterChange: setGlobalFilter,
    onSortingChange: setSorting,
    muiToolbarAlertBannerProps: isError ? { color: 'error', children: 'Error loading data' } : undefined,
    state: {
      columnFilters,
      globalFilter,
      pagination,
      sorting,
      showSkeletons: isRefetching,
      showAlertBanner: isError,
    },
    rowCount: totalCount ?? 0,
    muiTopToolbarProps: {},
    ...EMPLOYEE_TIMELINE_TABLE_DEFAULT_PROPS,
  });

  const breadcrumbs = [
    {
      label: 'Home',
      path: '/',
    },
    {
      label: 'Employees-Timeline',
      path: '',
    },
  ];
  return (
    <>
      <BreadCrumb breadcrumbs={breadcrumbs} />
      <Container>
        <Loading open={isLoading} />

        <Card>
          <TableWrapper>
            <MaterialReactTable table={table} />
          </TableWrapper>
        </Card>
      </Container>
    </>
  );
}

export default EmployeesTimelineTable;
